import connectToStores from 'alt-utils/lib/connectToStores'
import { Link } from 'react-router'
import { ChargeUtils } from 'utils'
import { List, ListItem } from 'material-ui/List'
import FontIcon from 'material-ui/FontIcon'
import LinearProgress from 'material-ui/LinearProgress'
import { SEOSettingsActions } from 'actions'
import { SEOSettingsStore } from 'stores'
import { Button, SimpleCard } from 'components'
import { TemplateUtils, Enum } from 'utils'
import { API_BASE } from 'consts'

import './seoToolsContainer.scss'

const iconStyles = {
  fontSize: "36px"
};
const pageTitleTemplates = [
  'Product',
  'Collection',
  'Article',
  'Blog',
  'Page',
  'Index',
  'Catalog',
  'Search',
  '404',
  'Default'
]

@connectToStores
export default class SeoToolsContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
    muiTheme: React.PropTypes.object
  }

  static propTypes = {
    settings: React.PropTypes.object
  }

  static getStores() {
    return [SEOSettingsStore]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState()
    }
  }

  componentWillMount() {
    if (!this.props.settings) {
      SEOSettingsActions.fetch()
    }
  }

  getStructuredDataStatus(settings) {
    const isLogoDefined = settings['structuredDataDisplayLogo']

    if (isLogoDefined) {
      return 0
    } else {
      return 1
    }
  }

  getPageTitleStatus(settings) {
    const criticalities = pageTitleTemplates.map(resourceName => {
      let criticality
      const titleTemplateStr = settings[`pageTitle${resourceName}Template`]
      const descriptionTemplateStr =
        settings[`metaDescription${resourceName}Template`]

      if (resourceName === 'Index') {
        criticality = titleTemplateStr && descriptionTemplateStr ? 0 : 2
      } else {
        const titleCriticality = TemplateUtils.getCriticality(
          titleTemplateStr,
          Enum.TitleTemplateFormula[resourceName],
          Enum.TitleTemplateChecklist[resourceName]
        )
        const descriptionCriticality = TemplateUtils.getCriticality(
          descriptionTemplateStr,
          Enum.DescriptionTemplateFormula[resourceName],
          Enum.DescriptionTemplateChecklist[resourceName]
        )
        criticality = Math.max(titleCriticality, descriptionCriticality)
      }

      return criticality
    })

    return Math.max(...criticalities)
  }

  renderStatusIcon(criticality) {
    const { palette } = this.context.muiTheme

    switch (criticality) {
      case 0:
        return (
          <FontIcon
            className="material-icons"
            style={{ ...iconStyles, color: palette.green }}
          >
            check
          </FontIcon>
        )
      case 1:
        return (
          <FontIcon
            className="material-icons"
            style={{ ...iconStyles, color: palette.yellow }}
          >
            warning
          </FontIcon>
        )
      case 2:
        return (
          <FontIcon
            className="material-icons"
            style={{ ...iconStyles, color: palette.red }}
          >
            clear
          </FontIcon>
        )
      default:
        return null
    }
  }

  renderStatusText(criticality) {
    switch (criticality) {
      case 0:
        return 'Set up complete!'
      case 1:
        return 'Worthwhile enhancements available'
      case 2:
        return 'Important set up needed'
      default:
        return null
    }
  }

  renderPlaceholderList() {
    return (
      <div className="dashboard__seoTools__list">
        <div className="dashboard__seoTools__item">
          <div className="dashboard__seoTools__item__status">
            {this.renderStatusIcon(0)}
          </div>
          <div className="dashboard__seoTools__item__copy">
            <h3>Page Titles and Descriptions</h3>
            <p className="foreground-black">{this.renderStatusText(0)}</p>
          </div>
          <div className="dashboard__seoTools__item__action">
            <Button label="Edit Settings" buttonType="secondary" />
          </div>
        </div>
        <div className="dashboard__seoTools__item">
          <div className="dashboard__seoTools__item__status">
            {this.renderStatusIcon(1)}
          </div>
          <div className="dashboard__seoTools__item__copy">
            <h3>JSON-LD Structured Data</h3>
            <p className="foreground-black">{this.renderStatusText(1)}</p>
          </div>
          <div className="dashboard__seoTools__item__action">
            <Button label="Set up Now" buttonType="secondary" />
          </div>
        </div>
        <div className="dashboard__seoTools__overlay">
          <h4>
            Improve your SEO in minutes with powerful Plug in SEO Plus tools
          </h4>
          <div className="medium-spacing--top">
            <Button
              label="Upgrade to Plus"
              buttonType="secondary"
              onTouchTap={() => {
                window.location.replace(`${API_BASE}/v3ui/pricing`)
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { settings, placeholder } = this.props
    const { palette } = this.context.muiTheme
    const seoToolsTitle = (
      <span>
        <span>SEO Tools</span>
        <span className="dashboard__seoTools__plus-tag">Plus</span>
      </span>
    )

    if (placeholder) {
      return (
        <SimpleCard title={seoToolsTitle} className="dashboard__seoTools">
          {this.renderPlaceholderList()}
        </SimpleCard>
      )
    }

    if (!settings) {
      return (
        <SimpleCard title={seoToolsTitle} className="dashboard__seoTools">
          <div className="dashboard__seoTools__loading">
            <h4 className="dashboard__seoTools__loading__header">Loading your SEO Tools...</h4>
            <LinearProgress mode="indeterminate" />
          </div>
        </SimpleCard>
      )
    }

    const sdStatus = this.getStructuredDataStatus(settings)
    const pageTitleStatus = this.getPageTitleStatus(settings)

    return (
      <SimpleCard 
        title={seoToolsTitle} 
        info={true}
        link="https://support.pluginuseful.com/"
        className="dashboard__seoTools">
        <div className="dashboard__seoTools__list">
          <div
            className="dashboard__seoTools__item"
            onClick={() => this.context.router.push('/plus/title-description')}
          >
            <div className="dashboard__seoTools__item__status">
              {this.renderStatusIcon(pageTitleStatus)}
            </div>
            <div className="dashboard__seoTools__item__copy">
              <h3>Page Titles and Descriptions</h3>
              <p className="foreground-black">
                {this.renderStatusText(pageTitleStatus)}
              </p>
            </div>
            <div className="dashboard__seoTools__item__action">
              <Button
                label={pageTitleStatus ? 'Set up Now' : 'Edit Settings'}
                buttonType="secondary"
                onClick={e => {
                  e.stopPropagation()
                  this.context.router.push('/plus/title-description')
                }}
              />
            </div>
          </div>
          <div
            className="dashboard__seoTools__item"
            onClick={() => this.context.router.push('/plus/structured-data')}
          >
            <div className="dashboard__seoTools__item__status">
              {this.renderStatusIcon(sdStatus)}
            </div>
            <div className="dashboard__seoTools__item__copy">
              <h3>JSON-LD Structured Data</h3>
              <p className="foreground-black">
                {this.renderStatusText(sdStatus)}
              </p>
            </div>
            <div className="dashboard__seoTools__item__action">
              <Button
                label={sdStatus ? 'Set up Now' : 'Edit Settings'}
                buttonType="secondary"
                onClick={e => {
                  e.stopPropagation()
                  this.context.router.push('/plus/structured-data')
                }}
              />
            </div>
          </div>
        </div>
      </SimpleCard>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/dashboard/SeoToolsContainer.js